export interface SessionData {
  name: string;
  phone: string;
  email: string;
  selectedDocuments: File[];
  sessionId: number | null;
  sessionToken: string | null;
  documentsSkipped: boolean;
}

export const emptySessionData = (): SessionData => ({
  name: "",
  phone: "",
  email: "",
  selectedDocuments: [],
  sessionId: null,
  sessionToken: null,
  documentsSkipped: false,
});

export type StepKey = "contact" | "documents" | "review" | "how" | "confirmation";

export const STEPS: { key: StepKey; title: string }[] = [
  { key: "contact",      title: "Your Information" },
  { key: "documents",    title: "Upload Documents" },
  { key: "review",       title: "Review" },
  { key: "how",          title: "What to Expect" },
  { key: "confirmation", title: "Confirmation" },
];
